import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import { SchemaOrg } from '@/components/base/SchemaOrg';
import HeroBanner from './components/HeroBanner';
import CategoryNav from './components/CategoryNav';
import MovieGrid from './components/MovieGrid';
import FeaturedSection from './components/FeaturedSection';
import FAQSection from './components/FAQSection';
import { movies } from '@/mocks/movies';

export default function Home() {
  const hotMovies = movies.filter((m) => m.isHot);
  const newMovies = movies.filter((m) => m.isNew);
  const recommendedMovies = movies.filter((m) => m.isRecommended);
  const featuredMovie = movies.find((m) => m.id === 'm1') || movies[0];

  return (
    <>
      <SchemaOrg type="WebSite" />
      <SchemaOrg
        type="WebPage"
        pageTitle="八戒影院 - 最新影视资源同步更新，热播剧新片上线抢先看不缓冲"
        pageDescription="八戒影院持续同步更新最新影视资源，热播剧与新片上线抢先看不缓冲。汇聚免费电视剧全集与电影大全，高清在线流畅播放。"
      />
      <ScrollToTop />
      <Navbar />
      <main>
        <HeroBanner />
        <CategoryNav />
        <FeaturedSection movie={featuredMovie} />
        <MovieGrid
          title="热播推荐"
          subtitle="大家都在看的热门影视"
          movies={hotMovies}
          viewAllLink="/category/all"
        />
        <MovieGrid
          title="最新上线"
          subtitle="刚上线的新片新剧，抢先观看"
          movies={newMovies}
          viewAllLink="/category/all"
        />
        <MovieGrid
          title="高分推荐"
          subtitle="口碑爆棚的优质影视作品"
          movies={recommendedMovies}
          viewAllLink="/category/all"
        />
        <FAQSection />
      </main>
      <Footer />
    </>
  );
}